import styled from "styled-components";
import { IonContent } from "@ionic/react";

export const Container = styled(IonContent)`
  position: relative;
`;

export const ModalContent = styled.div`
  height: 70vh;
  margin-top: 15vh;
`;

export const Footer = styled.div`
  position: absolute;
  bottom: 0;
  height: 80px;
  background-color: black;
  width: 100%;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  display: flex;
  align-items: center;
  padding: 0 30px 0 30px;
  justify-content: space-between;
`;

export const IconContaner = styled.div`
  height: 50px;
  width: 50px;
  background-color: ${(props) => props.color};
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  font-family: "Rubik";
  font-weight: bold;
`;

export const ButtonContaner = styled.div`
  height: 50px;
  width: 50px;
  background-color: ${(props) => props.color};
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Rubik";
  font-weight: bold;
  padding: 0 35px 0 35px;
`;

export const SelectContaner = styled.div`
  height: 50px;
  background-color: ${(props) => props.color};
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  padding: 0 10px 0 10px;
`;
